import { match } from 'ts-pattern'

import {
  DesktopIcon,
  MobileIcon,
  QuestionIcon,
  TabletIcon,
} from '@blade/ui-kit'

import type { Session } from '../../model'
import type { ClassNameProps } from '@root/shared/react'

type SessionDeviceIconProps = {
  deviceType: Session.DeviceType
} & ClassNameProps

export const SessionDeviceIcon: React.FC<SessionDeviceIconProps> = ({
  deviceType,
}) => {
  const Icon = match(deviceType)
    .with('mobile', () => MobileIcon)
    .with('desktop', () => DesktopIcon)
    .with('tablet', () => TabletIcon)
    .with('unknown', () => QuestionIcon)
    .exhaustive()
  // eslint-disable-next-line react-hooks/static-components
  return <Icon size={24} />
}
